import * as Turbo from '@hotwired/turbo'

Turbo.session.drive = false

export function useTurboNavigate() {
  const navigate = (fullUrl, streamPath, frameName) => {
    const [url, hash] = fullUrl.split('#')

    window.currentTurboVisitURL = hash ? `${url}#${hash}` : url

    Turbo.visit(`${url}/${streamPath}`, { frame: frameName })
  }

  return navigate
}
